<script setup>
import {onBeforeMount, reactive} from 'vue'
import {State, clone, getModels} from '@/paks/vu-app'
import DashRange from './DashRange.vue'
import CssEdit from './CssEdit.vue'

const {modelValue: board} = defineProps({modelValue: Object})

const emit = defineEmits(['update:modelValue'])

const page = reactive({
    askRange: false,
    boardName: null,
    grid: null,
    hasMetrics: null,
})

onBeforeMount(() => {
    page.isPage = board.type == 'page'
    page.hasMetrics =
        (page.isPage || State.config.features.dash.metrics) && board.widgets.filter((w) => w.metric).length
            ? true
            : false
    page.grid = board.layout != 'grid' ? false : true
    page.boardName = board.name
})

/* 
    Don't wait here as it will delay the blur event until after the button is clicked
 */
function setBoardName(name) {
    if (board.name == 'New Dashboard') {
        //  Initialize and clear the name
        emit('update:modelValue', {layout: 'grid', widgets: [], toolbar: true})
    } else if (name != board.name) {
        //  See if the name is free
        let dash = State.cache.dashboards.find(d => d.name == name)
        if (dash) {
            //  Name already in use
            let validate = primary.value.validate
            if (validate) {
                validate.clear()
                validate.fieldError(primary.value, 'name', 'Dashboard name already in use')
            }
        } else {
            let newBoard = clone(board)
            newBoard.name = name
            emit('update:modelValue', newBoard)
        }
    }
}
</script>

<template>
    <div class="page-appearance-edit">
        <vu-input
            v-if="!page.isPage"
            v-model="page.boardName"
            label="Dashboard Name"
            name="name"
            placeholder="Enter title"
            type="text"
            class="mb-2"
            @update:modelValue="setBoardName" />

        <div class="vrow">
            <vu-input
                label="Design Layout"
                v-model="board.layout"
                cols="4"
                type="switch"
                inset
                :items="{true: 'grid', false: 'exact'}"
                :suffix="page.grid ? 'Grid' : 'Exact'"
                @update:modelValue="$emit('update:modelValue', board)" />
            <vu-input label="Framed Widgets" v-model="board.framed" type="switch" cols="4" inset />
            <vu-input type="switch" v-model="board.toolbar" label="Show Toolbar" cols="4" inset />
        </div>

        <vu-input
            type="text"
            v-model="board.refresh"
            label="Refresh"
            placeholder="Seconds"
            :clearable="false"
            suffix="secs"
            cols="6" />

        <vu-input
            v-if="!State.app.mobile"
            type="select"
            v-model="board.emulate"
            label="Emulate"
            :items="['None', 'Mobile', 'Desktop']"
            cols="6" />

        <vu-input v-if="page.hasMetrics" v-model="page.askRange" type="checkbox" label="Time Range" hide-details />

        <DashRange v-if="page.hasMetrics && page.askRange" v-model="board.range" mode="date" />

        <CssEdit v-model="board.css" :simple="true" name="board-css" title="CSS Properties" class="mb-2" />
        <CssEdit v-model="board.widgetCss" :simple="false" name="widget-css" title="Widget CSS Properties" class="mb-3" />
    </div>
</template>

<style lang="scss">
.page-appearance-edit {
    display: flex;
    flex-wrap: wrap;
    column-gap: 12px;
    width: 100%;
    .css-edit {
        .table-title {
            font-size: 1.4rem !important;
        }
    }
}
</style>
